export enum AttributeType {
    builtinAttribute = 1,
    customAttribute = 2
  }
  